a  <template lang="pug">
  div.mainDashboard
    keep-alive
      transition(name='fade' appear)
        router-view(
          ref='rou'
          @controlLoad='controlLoad'
        )
    CesiumMapObject(ref='cesiumMapObject' :class='showMap === true ? "mapVisible" : "mapNoVisible"')
</template>

<script>
import CesiumMapObject from '@/components/CesiumMapObject'
let myLoadMapElem = null
// let myLoadMapElem2 = null
export default {
  name: 'MainDashboard',
  data () {
    return {
      cityChange: false,
      meview: 'dashboard',
      showMap: false,
      Basemap: {}
    }
  },
  methods: {
    getStation (data) {
      this.$refs.rou.$refs.verticalGeneric.getSelectedStation(data)
    },
    controlLoad () {
      const component = this
      myLoadMapElem = setInterval(myLoadMap, 500)
      function myLoadMap () {
        if (component.$refs.cesiumMapObject.getLoad() === true) {
          if (component.$refs.rou.$refs.mainPark) {
            component.$refs.rou.$refs.mainPark.setMapLoad()
          } else if (component.$refs.rou.$refs.mobility) {
            component.$refs.rou.setMapLoad()
          } else {
            component.$refs.rou.setMapLoad()
          }
          component.updateMap()
          clearInterval(myLoadMapElem)
        }
      }
    },
    setCity () {
      if (this.cityChange === true) {
        this.cityChange = false
      }
    },
    updateMap () {
      const component = this
      if (component.$refs.rou.$refs.meteoTools) {
        component.$refs.rou.$refs.mapZoom.z3D = component.$store.state.globales.btn3D
      } else if (component.$refs.rou.$refs.mainPark) {
        component.$refs.rou.$refs.mainPark.$refs.mapZoom.z3D = component.$store.state.globales.btn3D
      }
      var myLoadMapElem2 = setInterval(myLoadMap, 500)
      function myLoadMap () {
        if (component.$refs.cesiumMapObject.getLoad() === true) {
          if (!component.isEmpty(component.$refs.rou.$refs)) {
            if (component.$refs.rou.$refs.meteoTools) {
              component.$refs.rou.$refs.mapZoom.z3D = component.$store.state.globales.btn3D
              document.getElementById('dataIframe').contentWindow.mapClear()
              component.$refs.rou.$refs.meteoTools.filterInitial()
              if (component.cityChange === true) {
                component.$refs.rou.$refs.meteo.updateSelectedStation()
              }
            } else if (component.$refs.rou.$refs.mainPark) {
              component.$refs.rou.$refs.mainPark.$refs.mapZoom.z3D = component.$store.state.globales.btn3D
              document.getElementById('dataIframe').contentWindow.mapClear()
              component.$refs.rou.$refs.mainPark.$refs.parkTools.filterInitial()
              if (component.$refs.rou.$refs.mainPark.$refs.park) {
                if (component.cityChange === true) {
                  component.$refs.rou.$refs.mainPark.$refs.park.updateSelectedStation()
                }
              }
            }
            component.setCity()
          }
          clearInterval(myLoadMapElem2)
        }
      }
    },
    updateGenericMap () {
      const component = this
      component.$refs.rou.$refs.mapZoom.z3D = component.$store.state.globales.btn3D
      var myLoadMap = () => {
        if (component.$refs.cesiumMapObject.getLoad() === true) {
          // llamamos al servicio de mapa base
          const data = {
            method: 'GET',
            url: process.env.SERVICES_PROVIDER + '/api/dashboard/getBaseMaps',
            headers: {
              Accept: 'application/json',
              Authorization: `${sessionStorage.getItem('sessionToken')}`
            },
            params: null,
            mutation: 'UPDATE_BASEMAP'
          }
          if (component.$store.getters.getBasemap === null) {
            component.$store.dispatch('updateCallService', data)
          }
          component.$refs.rou.setMapLoad()
          clearInterval(myLoadMapElem2)
        }
      }
      var myLoadMapElem2 = setInterval(myLoadMap, 500)
    },
    isEmpty (obj) {
      // console.log(obj)
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false
        }
      }
      return true
    },
    controlMap () {
      if (this.$route.name === 'MobilityAndTransportMain' || this.$route.name === 'CruisesMain' || this.$route.name === 'ParksAndGardensMain' || this.$route.name === 'EnvironmentDashboard' || this.$route.name === 'ParksAndGardensDashboard' || this.$route.name === 'CruisesMain' || this.$route.name === 'CRMDashboard') {
        this.updateGenericMap()
        // mostramos el componente mapa
        this.showMap = true
      } else {
        // Este vertical no muestra el mapa.
        this.showMap = false
      }
    }
  },
  components: {
    CesiumMapObject
  },
  created () {
  },
  mounted () {
    const component = this
    window.document.addEventListener('myCustomEvent', handleEvent, false)
    window.document.addEventListener('controlCity', controlCity, false)
    function handleEvent (e) {
      component.getStation(e.detail)
    }
    function controlCity (e) {
      component.cityChange = true
      if (component.$refs.rou.$refs.verticalGeneric) {
        // Actualizamos la seleccion por ciudad
        component.$refs.rou.$refs.verticalGeneric.updateSelectedStation(component.$refs.rou.tabsVertical)
        // Actualizamos la legenda a los elementos por defecto.
        component.$refs.rou.$refs.legendMap.open = component.$refs.rou.$refs.legendMap.data = false
      }
    }
    this.controlMap()
  },
  updated () {
    // const component = this
    this.controlMap()
  }
}

</script>

<style lang="scss" scoped>

.mapVisible {
  visibility: visible;
}
.mapNoVisible {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}
</style>



// WEBPACK FOOTER //
// src/views/mainDashboard.vue